/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ZandaHealth API
 * OpenAPI spec version: 1.0
 */

export type AppointmentType =
  (typeof AppointmentType)[keyof typeof AppointmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppointmentType = {
  ClientAppointment: 1,
  PersonalAppointment: 2,
  GroupAppointment: 3,
} as const;
